import { ROUTES } from '@/routes';
import { SHOW_PRICING } from '@/lib/flags';
import type { ParseKeys } from 'i18next';

export interface NavLinkItem {
  to: string;
  i18nKey: ParseKeys<'nav'>;
}

export const PRIMARY_NAV_LINKS: readonly NavLinkItem[] = [
  { to: ROUTES.features, i18nKey: 'links.features' },
  { to: ROUTES.howItWorks, i18nKey: 'links.how_it_works' },
  { to: ROUTES.download, i18nKey: 'links.download' },
  ...(SHOW_PRICING ? [{ to: ROUTES.pricing, i18nKey: 'links.pricing' as ParseKeys<'nav'> }] : []),
  { to: ROUTES.changelog, i18nKey: 'links.changelog' },
];

export const FOOTER_PRODUCT_LINKS: readonly NavLinkItem[] = [
  { to: ROUTES.features, i18nKey: 'links.features' },
  { to: ROUTES.download, i18nKey: 'links.download' },
  ...(SHOW_PRICING ? [{ to: ROUTES.pricing, i18nKey: 'links.pricing' as ParseKeys<'nav'> }] : []),
  { to: ROUTES.changelog, i18nKey: 'links.changelog' },
];

export const FOOTER_RESOURCES_LINKS: readonly NavLinkItem[] = [
  { to: ROUTES.howItWorks, i18nKey: 'links.how_it_works' },
  { to: ROUTES.faq, i18nKey: 'links.faq' },
] as const;

export const FOOTER_LEGAL_LINKS: readonly NavLinkItem[] = [
  { to: ROUTES.privacy, i18nKey: 'links.privacy' },
  { to: ROUTES.terms, i18nKey: 'links.terms' },
  { to: ROUTES.legalDpa, i18nKey: 'links.dpa' },
] as const;
